import templates from './templates.js';

export function generateUrl (templateName, kwargs) {
  // TODO: make this smarter
  return templates[templateName]
    .replace(':id', kwargs.id)
    .replace(':slug', kwargs.slug);
}
